import { getByName } from "@/enums/taxType";
import func from "@/funcs";

export function getFoodKind() {
  return {
    FontSize: 16,
    ForeColor: "#FFFFFF",
    BackColor: "#6297FF",
  };
}

export function getFood() {
  return {
    FontSize: 16,
    ForeColor: "#FFFFFF",
    BackColor: "#F29A2B",
    TaxType: getByName("YTax").value,
  };
}

export function getPay() {
  return {
    FontSize: 16,
    ForeColor: "#FFFFFF",
    BackColor: "#16418F",
    Price: 0,
    AccountId: null,
  };
}

export function getPage() {
  return {
    CurrentPage: 1,
    PageNumber: 0,
    PageSize: 25,
    HasPrevious: false,
    HasNext: false,
  };
}

export function getDayModule() {
  return {
    DayBegin: null,
    DayEnd: null,
    Sunday: true,
    Monday: true,
    Tuesday: true,
    Wednesday: true,
    Thursday: true,
    Friday: true,
    Saturday: true,
    HourBegin: 0,
    HourEnd: 0,
    MinuteBegin: 0,
    MinuteEnd: 0,
  };
}

export function getHolidayModule() {
  return {
    StartDate: func.getDate(),
    EndDate: func.getDate(),
    HourBegin: 0,
    HourEnd: 23,
    MinuteBegin: 0,
    MinuteEnd: 59,
    IsAllDay: true,
    Memo: "",
  };
}

export function getRequisition() {
  return {
    RequisitionDate: func.getDate(),
    // 無第三方 ERP 且未啟用簽核時，新單狀態為「未採購」。
    StatusType: func.canUseRequisitionWorkflow() ? 2 : 0,
  };
}

export function getPurchase() {
  return {
    PurchaseDate: func.getDate(),
    WarehouseName: null,
    BuyerName: null,
    SupplierName: null,
    TaxType: 1,
    IsTaxAddition: false,
    InvoiceNumber: "",
  };
}

export function getSale() {
  return {
    BusinessDay: func.getDate(),
    WarehouseName: null,
    CustomerName: null,
    SalerName: null,
    TaxType: 1,
    IsTaxAddition: false,
    Address: "",
  };
}

export function getCombinationTrade(tradeType) {
  return {
    CombinationTradeDate: func.getDate(),
    FoodName: null,
    WarehouseName: null,
    TradeType: tradeType,
    Qty: null,
    Total: 0,
    Memo: null,
    HasBatchNumber: false,
    BatchNumber: null,
  };
}

export function getOnlineOrderMenu(type) {
  return {
    OnlineOrderType: type,
  };
}

export function getOnlineOrderCategory(type) {
  return {
    OnlineOrderType: type,
  };
}

export function getOnlineOrderModifierGroup(type) {
  return {
    OnlineOrderType: type,
  };
}

export function getOnlineOrderItem(type) {
  return {
    OnlineOrderType: type,
  };
}

export function getMemberDegreeRules(degrees) {
  const customerDegreeName = JSON.parse(
    window.localStorage["customerDegreeName"]
  );
  const nameArr = [
    customerDegreeName.CustomerDegreeZero
      ? customerDegreeName.CustomerDegreeZero
      : "零級",
    customerDegreeName.CustomerDegreeOne
      ? customerDegreeName.CustomerDegreeOne
      : "一級",
    customerDegreeName.CustomerDegreeTwo
      ? customerDegreeName.CustomerDegreeTwo
      : "二級",
    customerDegreeName.CustomerDegreeThree
      ? customerDegreeName.CustomerDegreeThree
      : "三級",
    customerDegreeName.CustomerDegreeFour
      ? customerDegreeName.CustomerDegreeFour
      : "四級",
    customerDegreeName.CustomerDegreeFive
      ? customerDegreeName.CustomerDegreeFive
      : "五級",
    customerDegreeName.CustomerDegreeSix
      ? customerDegreeName.CustomerDegreeSix
      : "六級",
  ];
  let rules = [];
  if (degrees > 0) {
    for (let i = 1; i < degrees; i++) {
      rules.push({
        Degree: i,
        UpgradeValidMonths: 0,
        RenewValidMonths: 0,
        UpgradeRules: [],
        RenewRules: [],
        MemberDegreeRuleText: nameArr[i],
        LastMemberDegreeRuleText: nameArr[i - 1],
      });
    }
  }
  return rules;
}
